import {replaceDateFields} from "../../utils/modelConverter";
import {call} from "redux-saga-test-plan/matchers";
import {updateArtist} from "../../../api/artistApi";
import {reloadCommonArtistsAction} from "../../common/commonActions";
import {emitNotificationAction} from "../../notification/notificationAction";
import {put} from "redux-saga/effects"

export function* processUpdateArtist(artistData, successNotification, failureNotification) {
    try {
        const artist = replaceDateFields(artistData)
        yield call(updateArtist, {artist})
        yield put(reloadCommonArtistsAction())
        yield put(emitNotificationAction(successNotification))
    } catch (err) {
        yield put(emitNotificationAction(failureNotification))
        console.log(err)
    }
}